import PropTypes from 'prop-types';
import './styles/notificationStyles.css';

import { CloseButton } from 'Buttons';

import NotificationStatusIcon from './NotificationStatusIcon';

const notificationTypeStyles = {
  danger: 'bg-red-1 border-red-3 text-red-4',
  info: 'bg-blue-1 border-blue-3 text-blue-4',
  pantheor: 'bg-purple-1 border-purple-3 text-purple-4',
  success: 'bg-green-1 border-green-3 text-green-4',
  warning: 'bg-orange-1 border-orange-3 text-orange-5',
};

const NotificationBase = ({
  children,
  dismissCallback,
  iconAlt,
  isDismissible,
  variant,
  type,
  ...rest
}) => (
  <div
    className={`${notificationTypeStyles[type]} border-solid border ${
      variant === 'alert' && 'rounded'
    } mb-4 p-4 relative notification`}
    role="alert"
    {...rest}
  >
    <span className="flex flex-row mr-10">
      <NotificationStatusIcon alt={iconAlt} type={type} />
      <span>{children}</span>
    </span>
    {isDismissible && (
      <CloseButton
        callback={dismissCallback}
        className={
          'absolute text-opacity-60 right-4 text-lg top-2 hover:text-opacity-100'
        }
        type={type}
      />
    )}
  </div>
);

NotificationBase.defaultProps = {
  dismissCallback: () => {},
  iconAlt: '',
  isDismissible: false,
  variant: 'alert',
};

NotificationBase.propTypes = {
  children: PropTypes.node.isRequired,
  dismissCallback: PropTypes.func,
  iconAlt: PropTypes.string,
  isDismissible: PropTypes.bool,
  type: PropTypes.oneOf(['danger', 'info', 'pantheor', 'success', 'warning'])
    .isRequired,
  variant: PropTypes.oneOf(['alert', 'announcement']),
};

export default NotificationBase;
